import { render } from "./TopicItem.vue?vue&type=template&id=77eba50c&scoped=true"
import script from "./TopicItem.vue?vue&type=script&lang=ts"
export * from "./TopicItem.vue?vue&type=script&lang=ts"

import "./TopicItem.vue?vue&type=style&index=0&id=77eba50c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-77eba50c"

export default script